import { computed } from 'vue'

export default {
    name: 'TeamListCard',
    props: {
        participantsText: {
            type: String,
            required: true
        },
        captainText: {
            type: String,
            required: true
        },
        captains: {
            type: Array,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        imageUrl: {
            type: String,
            required: true
        },
        imageAlt: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        membersCount: {
            type: Number,
            required: true
        },
        donationGoals: {
            type: Number,
            required: true
        },
        donationGoalsText: {
            type: String,
            required: true
        },
        currencyText: {
            type: String,
            required: true
        },
        donationTotal: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const formatAmount = (value) => {
            if (value === null || value === undefined) return ''

            return new Intl.NumberFormat('da-DK', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(Number(value))
        }

        const donationTotalFormatted = computed(() =>
            formatAmount(props.donationTotal)
        )

        const donationGoalsFormatted = computed(() =>
            formatAmount(props.donationGoals)
        )

        const progress = computed(() => {
            const progressCap = 100
            const rawProgress =
                (props.donationTotal * progressCap) / props.donationGoals
            return Math.min(rawProgress, progressCap)
        })

        return {
            progress,
            donationTotalFormatted,
            donationGoalsFormatted
        }
    }
}
